import React, { useEffect, useState } from "react";
import { MenuHeader } from "./MenuHeader";
import { MenuItem } from "./MenuItem";

import { User } from "../../app/user/userSlice";
import { useSelector } from "react-redux";
import ordersImg from "../../images/icons/orders-icon.svg";
import uploadOrderImg from "../../images/icons/upload-order-icon.svg";
import ocurrencesImg from "../../images/icons/ocurrences.svg";

let menutiems = [
  {
    text: "Gestión",
    url: "/orders",
    icon: ordersImg,
    id: "6",
    check: false,
  },
  {
    text: "Carga Masiva",
    url: "/upload/order",
    icon: uploadOrderImg,
    id: "7",
    check: false,
  },
  {
    text: "Novedades",
    url: "/ocurrences",
    icon: ocurrencesImg,
    id: "8",
    check: false,
  },
];

export const Menu = ({ openMenu, handelOpenMenu }) => {
  const user = useSelector(User);
  const [optionsMenu, setOptionsMenu] = useState(null);
  const getEmail = JSON.parse(localStorage.getItem("dbhuseread"));

  const { username } = getEmail;
  
  useEffect(() => {
    const getPermisos = menutiems?.map((permisoMenu) => {
      let findPermisos = user?.permisosMenu?.find(
        (permiso) => permisoMenu.id === permiso.idPermiso
      ) ;
      if (findPermisos != null || menutiems.id !== "6" || menutiems.id !== "7" || menutiems.id !== "8") {
        permisoMenu.check = true;
      }
      return permisoMenu;
    });
    setOptionsMenu(getPermisos);
  }, [user?.permisosMenu]);

  useEffect(() => {
  }, [username]);

  return (
    <div className="menu">
      <MenuHeader openMenu={openMenu} handelOpenMenu={handelOpenMenu} />
      <div className="menu__list">
        {optionsMenu?.map((menuitem, index) => (
          <MenuItem
            key={index}
            check={menuitem.check}
            menuitem={menuitem}
            openMenu={openMenu}
          />
        ))}
      </div>
    </div>
  );
};
